import { useState } from 'react';
import * as Yup from 'yup';

import { FormErrorType } from '../services/forms/FormHelpers';

export const useFormValidation = <TFormData,>(
  schema: Yup.ObjectSchema<any>,
  initialFormData: TFormData,
  initalErrors?: FormErrorType | undefined
) => {
  const [formData, setFormData] = useState<TFormData>(initialFormData);
  const [errors, setErrors] = useState<FormErrorType>(initalErrors ?? {});

  const formChange =
    (field: keyof TFormData) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({
        ...formData,
        [field]: e.target.value,
      });
    };

  const formValidate = async (
    successCallback: () => void | Promise<void> | undefined
  ) => {
    console.log("useFormValidation: Starting validation", {
      formData,
      schema: schema.describe(),
    });

    console.log("useFormValidation: About to validate with schema", {
      formData,
      schemaFields: Object.keys(schema.fields),
    });

    try {
      await schema.validate(formData, { abortEarly: false });
      console.log("useFormValidation: Validation passed");
      setErrors({});

      // Await the success callback to ensure it completes before returning
      if (successCallback) {
        await successCallback();
      }

      return true;
    } catch (err: unknown) {
      console.log("useFormValidation: Validation failed", err);

      if (err instanceof Yup.ValidationError) {
        const fieldErrors: Record<string, string> = {};
        err.inner.forEach((e) => {
          if (e.path) fieldErrors[e.path] = e.message;
        });
        console.log("useFormValidation: Setting field errors", fieldErrors);
        setErrors(fieldErrors);
        console.log("useFormValidation: Errors state updated", fieldErrors);

        // Return false to indicate validation failed
        return false;
      }

      // For non-validation errors, also return false
      return false;
    }
  };

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    formChange,
    formValidate,
  };
};
